import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import StudentCard from "../Students/StudentCard";

const Student = (props: any) => {
  const { data } = props;

  return (
    <Card>
      <CardHeader className="bg-transparent">
        <div className="d-flex align-items-start">
          <div className="flex-grow-1">
            <h5 className="card-title mb-0">Students</h5>
          </div>
        </div>
      </CardHeader>
      <CardBody>
        {data.length === 0 && (
          <p className="text-muted mb-0">No students.</p>
        )}
        {data.map((student: any) => (
          <div key={student.id} className="mb-3">
            <StudentCard student={student} />
          </div>
        ))}
      </CardBody>
    </Card>
  );
};

export default Student;
